// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { SubMenuSectionFragmentDoc } from './SubMenuSection.fragment.generated';
import { SubMenuItemFragmentDoc } from './SubMenuItem.fragment.generated';
import { LinkFragmentDoc, LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from '../../../../cms/index.generated';
import { ImageLargeFragmentDoc } from '../../../../cms/imageLarge.fragment.generated';
import { ImageCommonFragmentDoc } from '../../../../cms/imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../../../cms/imageSize.fragment.generated';
import { SubMenuEditorialContentFragmentDoc } from './SubMenuEditorialContent.fragment.generated';
export const SubMenuFragmentDoc = `
    fragment subMenu on SubMenu {
  __typename
  title
  description
  useLargeFormatItems
  sections {
    ...subMenuSection
  }
  editorialContent {
    ...subMenuEditorialContent
  }
}
    `;